import {Button, Dropdown} from "antd"
import React from 'react'
import ClubMemberEditPhone from "./component/ClubMemberEditPhone"
import ClubMemberEditDiamond from "./component/ClubMemberEditDiamond"
import ClubMemberEditWallet from "./component/ClubMemberEditWallet"
import ClubMemberEditLevel from "./component/ClubMemberEditLevel"
import {EditOutlined} from "@ant-design/icons"


const ClubMemberEdit = ({member}) => {
    const items = [
        {
            key: '1',
            label: (
                <ClubMemberEditPhone memberId={member.id} account={member.account}/>
            ),
        },
        {
            key: '2',
            label: (
                <ClubMemberEditDiamond memberId={member.id}/>
            ),
        },
        {
            key: '3',
            label: (
                <ClubMemberEditWallet memberId={member.id}/>
            ),
        },
        {
            key: '4',
            label: (
                <ClubMemberEditLevel memberId={member.id}/>
            )
        }

    ]

    return (<div>
        <Dropdown menu={{items}} arrow>
            <Button type={"primary"} icon={<EditOutlined />}>编辑</Button>
        </Dropdown>
    </div>)
}

export default ClubMemberEdit


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberEdit/ClubMemberEdit.js